<spinner *ngIf="isLoading"></spinner>
<div [ngClass]="getClasses()" *ngIf="!isLoading && !hideTable">
  <div class="account-center-table__head">
    <h3 class="account-center-table__title">{{ title }}</h3>
  </div>
  <cpds-alert *ngIf="alert" [intent]="alert.intent">
    <span>{{ alert.text }}</span>
  </cpds-alert>
  <ng-container *ngFor="let row of rows">
    <div [ngClass]="row.getClasses()">
      <ng-container *ngFor="let cell of row.getCells()">
        <div [ngClass]="cell.getClasses()">
          <span *ngIf="cell.policyLabel" class="policy-label">{{ cell.policyLabel }}</span>
          <span *ngIf="cell.dataText" class="account-center-table__data-text">{{ cell.dataText }}</span>
          <a
            *ngIf="cell.actionItem && cell.actionItem.actionType === actionType['Link']"
            class="text-link"
            href="{{ cell.actionItem.action }}"
          >
            {{ cell.actionItem.displayText }}
          </a>
          <a
            *ngIf="cell.actionItem && cell.actionItem.actionType === actionType['Method']"
            class="text-link"
            (click)="handleAction(cell.actionItem)"
          >
            {{ cell.actionItem.displayText }}
          </a>
          <button
            *ngIf="
              cell.actionItem &&
              (cell.actionItem.actionType === actionType['OpenWindow'] ||
                cell.actionItem.actionType === actionType['OpenModal'])
            "
            class="button-link"
            (click)="handleAction(cell.actionItem)"
          >
            {{ cell.actionItem.displayText }}
          </button>
          <ng-container
            *ngIf="cell.actionItem && cell.actionItem.actionType === actionType['RenderComponent']"
            [ngSwitch]="cell.actionItem.component"
          >
            <exchange-1035-breakdown
              *ngSwitchCase="'exchange-1035-breakdown'"
              [actionItem]="cell.actionItem"
            ></exchange-1035-breakdown>
            <cash-value
              *ngSwitchCase="'cash-value'"
              [forClient]="true"
              [cashValueQuote]="cell.actionItem.property"
            ></cash-value>
          </ng-container>
          <ng-container *ngIf="cell.tooltipText">
            <tooltip class="{{ cell.toolTipClass }}"><div tip [innerHtml]="cell.tooltipText"></div></tooltip>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
